

// 布局组件
import NavBar from './layout/NavBar.vue';
import Footer from './layout/Footer.vue';

// 通用组件
import UserList from './common/UserList.vue';
import QuestionCard from './common/QuestionCard.vue';
import Timer from './common/Timer.vue';
import AudioControls from './common/AudioControls.vue';
import ChatInput from './common/ChatInput.vue';

// 导出所有组件
export {
  
  // 布局组件
  NavBar,
  Footer,
  
  // 通用组件
  UserList,
  QuestionCard,
  Timer,
  AudioControls,
  ChatInput
};

// 组件安装函数 - 用于全局注册
const install = (Vue) => {
  Vue.component('NavBar', NavBar);
  Vue.component('Footer', Footer);
  Vue.component('UserList', UserList);
  Vue.component('QuestionCard', QuestionCard);
  Vue.component('Timer', Timer);
  Vue.component('AudioControls', AudioControls);
  Vue.component('ChatInput', ChatInput);
};

export default {
  install
}; 